// OWMap BSL1 — seed data for cultural circles + story coordinates
// Coordinates are real lat/lng; stories are evocative fictional placeholders that match each region's mythic vocabulary.

const CULTURES = {
  east_asia:   { id: "east_asia",   label: "东亚",          en: "East Asia",         color: "#D44832", bgTone: "rgba(212, 72, 50, 0.06)",  motif: "ink-wash" },
  europe:      { id: "europe",      label: "欧洲",          en: "Europe",            color: "#5B8FD6", bgTone: "rgba(91, 143, 214, 0.06)", motif: "gothic-arc" },
  middle_east: { id: "middle_east", label: "中东 · 北非",   en: "Middle East / N.Africa", color: "#D4A843", bgTone: "rgba(212, 168, 67, 0.06)", motif: "geometric" },
  south_asia:  { id: "south_asia",  label: "南亚 · 东南亚", en: "South / SE Asia",   color: "#3DAD6B", bgTone: "rgba(61, 173, 107, 0.06)", motif: "lotus" },
  americas:    { id: "americas",    label: "美洲",          en: "Americas",          color: "#B05A32", bgTone: "rgba(176, 90, 50, 0.06)",  motif: "totem" },
  africa:      { id: "africa",      label: "非洲",          en: "Africa",            color: "#E07840", bgTone: "rgba(224, 120, 64, 0.06)", motif: "tribal" },
};

// 36 coordinates total — 18 with stories ("active"), 18 ambient dots ("dormant")
// lat (-90..90), lng (-180..180)
const COORDS = [
  // — East Asia —
  { id: "dunhuang",    name: "敦煌",           region: "甘肃 · 中国",     lat: 40.14, lng: 94.66,  culture: "east_asia",   heat: 0.95, count: 12 },
  { id: "kyoto",       name: "京都",           region: "本州 · 日本",     lat: 35.01, lng: 135.77, culture: "east_asia",   heat: 0.74, count: 8 },
  { id: "lijiang",     name: "丽江",           region: "云南 · 中国",     lat: 26.87, lng: 100.23, culture: "east_asia",   heat: 0.42, count: 4 },
  { id: "jeju",        name: "济州",           region: "韩国",            lat: 33.49, lng: 126.50, culture: "east_asia",   heat: 0.30, count: 3 },
  { id: "hangzhou",    name: "杭州",           region: "浙江 · 中国",     lat: 30.27, lng: 120.15, culture: "east_asia",   heat: 0.55, count: 6 },
  { id: "ulan",        name: "乌兰巴托",       region: "蒙古",            lat: 47.92, lng: 106.92, culture: "east_asia",   heat: 0.18, count: 2 },

  // — Europe —
  { id: "reykjavik",   name: "雷克雅未克",     region: "冰岛",            lat: 64.13, lng: -21.94, culture: "europe",      heat: 0.88, count: 10 },
  { id: "venice",      name: "威尼斯",         region: "意大利",          lat: 45.44, lng: 12.32,  culture: "europe",      heat: 0.62, count: 7 },
  { id: "tromso",      name: "特罗姆瑟",       region: "挪威北部",        lat: 69.65, lng: 18.96,  culture: "europe",      heat: 0.71, count: 5 },
  { id: "porto",       name: "波尔图",         region: "葡萄牙",          lat: 41.15, lng: -8.61,  culture: "europe",      heat: 0.34, count: 3 },
  { id: "edinburgh",   name: "爱丁堡",         region: "苏格兰",          lat: 55.95, lng: -3.19,  culture: "europe",      heat: 0.46, count: 4 },
  { id: "santorini",   name: "圣托里尼",       region: "希腊",            lat: 36.39, lng: 25.46,  culture: "europe",      heat: 0.28, count: 2 },

  // — Middle East / N. Africa —
  { id: "petra",       name: "佩特拉",         region: "约旦",            lat: 30.32, lng: 35.44,  culture: "middle_east", heat: 0.81, count: 9 },
  { id: "marrakech",   name: "马拉喀什",       region: "摩洛哥",          lat: 31.63, lng: -8.00,  culture: "middle_east", heat: 0.66, count: 7 },
  { id: "isfahan",     name: "伊斯法罕",       region: "伊朗",            lat: 32.65, lng: 51.67,  culture: "middle_east", heat: 0.53, count: 5 },
  { id: "samarkand",   name: "撒马尔罕",       region: "乌兹别克斯坦",    lat: 39.65, lng: 66.96,  culture: "middle_east", heat: 0.39, count: 4 },
  { id: "luxor",       name: "卢克索",         region: "埃及",            lat: 25.69, lng: 32.64,  culture: "middle_east", heat: 0.24, count: 2 },

  // — South / SE Asia —
  { id: "varanasi",    name: "瓦拉纳西",       region: "印度",            lat: 25.32, lng: 82.97,  culture: "south_asia",  heat: 0.77, count: 8 },
  { id: "luang",       name: "琅勃拉邦",       region: "老挝",            lat: 19.88, lng: 102.13, culture: "south_asia",  heat: 0.41, count: 4 },
  { id: "bali",        name: "乌布",           region: "巴厘 · 印尼",     lat: -8.51, lng: 115.26, culture: "south_asia",  heat: 0.58, count: 6 },
  { id: "bhutan",      name: "廷布",           region: "不丹",            lat: 27.47, lng: 89.64,  culture: "south_asia",  heat: 0.32, count: 3 },
  { id: "kandy",       name: "康提",           region: "斯里兰卡",        lat: 7.29,  lng: 80.64,  culture: "south_asia",  heat: 0.20, count: 2 },

  // — Americas —
  { id: "cusco",       name: "库斯科",         region: "秘鲁",            lat: -13.53, lng: -71.97, culture: "americas",    heat: 0.69, count: 7 },
  { id: "oaxaca",      name: "瓦哈卡",         region: "墨西哥",          lat: 17.07, lng: -96.72, culture: "americas",    heat: 0.51, count: 5 },
  { id: "patagonia",   name: "巴塔哥尼亚",     region: "阿根廷",          lat: -50.34, lng: -72.27, culture: "americas",    heat: 0.44, count: 4 },
  { id: "newfound",    name: "纽芬兰",         region: "加拿大",          lat: 47.56, lng: -52.71, culture: "americas",    heat: 0.26, count: 3 },
  { id: "santafe",     name: "圣达菲",         region: "新墨西哥 · 美国", lat: 35.69, lng: -105.94, culture: "americas",   heat: 0.22, count: 2 },

  // — Africa —
  { id: "timbuktu",    name: "廷巴克图",       region: "马里",            lat: 16.77, lng: -3.00,  culture: "africa",      heat: 0.84, count: 9 },
  { id: "lalibela",    name: "拉利贝拉",       region: "埃塞俄比亚",      lat: 12.03, lng: 39.04,  culture: "africa",      heat: 0.49, count: 5 },
  { id: "zanzibar",    name: "桑给巴尔",       region: "坦桑尼亚",        lat: -6.16, lng: 39.20,  culture: "africa",      heat: 0.37, count: 4 },
  { id: "namibia",     name: "纳米布",         region: "纳米比亚",        lat: -24.66, lng: 15.31, culture: "africa",      heat: 0.29, count: 3 },
  { id: "dakar",       name: "达喀尔",         region: "塞内加尔",        lat: 14.72, lng: -17.47, culture: "africa",      heat: 0.21, count: 2 },

  // — Dormant ambient dots (no stories yet, just life) —
  { id: "d1", name: "", region: "", lat: 12,  lng: -60,  culture: "americas",    heat: 0, count: 0, dormant: true },
  { id: "d2", name: "", region: "", lat: -30, lng: 30,   culture: "africa",      heat: 0, count: 0, dormant: true },
  { id: "d3", name: "", region: "", lat: 60,  lng: 110,  culture: "east_asia",   heat: 0, count: 0, dormant: true },
  { id: "d4", name: "", region: "", lat: -20, lng: 145,  culture: "south_asia",  heat: 0, count: 0, dormant: true },
  { id: "d5", name: "", region: "", lat: 50,  lng: 30,   culture: "europe",      heat: 0, count: 0, dormant: true },
  { id: "d6", name: "", region: "", lat: 25,  lng: 60,   culture: "middle_east", heat: 0, count: 0, dormant: true },
];

const STORIES = {
  dunhuang: [
    { id: "dh1", title: "九色鹿的回声",       genre: "民间故事", style: "成人版", duration: "14:32", paid: false, plays: 28910,
      excerpt: "公元 538 年，一名画师在三窟北壁停笔。他听见鹿鸣自岩缝深处传来——那是一千四百年来，第一次有人听见。",
      gen: "AI · 改编自《佛说鹿王经》" },
    { id: "dh2", title: "藏经洞的最后一夜",   genre: "历史叙事", style: "历史版", duration: "18:11", paid: true,  plays: 12044,
      excerpt: "1900 年六月二十二日，王道士走入十六窟侧壁。他没有钥匙——壁缝自己开了。",
      gen: "考据 · 莫高窟编号 17 文献" },
    { id: "dh3", title: "月牙泉不会干涸",     genre: "自然奇谈", style: "儿童版", duration: "08:47", paid: false, plays: 9221,
      excerpt: "沙丘说她要把泉吞掉。泉笑了，说：你试过几千年了。",
      gen: "AI · 在地民间口述" },
  ],
  reykjavik: [
    { id: "rk1", title: "海拉的女儿们",       genre: "神话传说", style: "成人版", duration: "16:08", paid: false, plays: 18302,
      excerpt: "冬天的第一场极光出现时，老渔夫总会熄掉灯。他说，那是冥后在数她的孩子，不能打扰。",
      gen: "AI · 改编自北欧萨迦" },
    { id: "rk2", title: "黑沙滩的吟游诗人",   genre: "梦境故事", style: "成人版", duration: "11:55", paid: false, plays: 7651,
      excerpt: "如果你在 Reynisfjara 的浪声里听见吉他，请不要回头——他在为你写歌，但还没写完。",
      gen: "AI · 原创" },
  ],
  petra: [
    { id: "pt1", title: "玫瑰城下的水脉",     genre: "历史叙事", style: "历史版", duration: "19:24", paid: true,  plays: 14820,
      excerpt: "纳巴泰人懂得让一滴水穿越六公里岩层。他们不写书——他们让石头记得。",
      gen: "考据 · 约旦考古局档案" },
    { id: "pt2", title: "卡兹尼神殿的影子",   genre: "民间故事", style: "成人版", duration: "13:09", paid: false, plays: 9908,
      excerpt: "贝都因人说，黎明前一刻，影子会先于太阳到达卡兹尼。这是它独有的礼貌。",
      gen: "AI · 在地口述采集" },
  ],
  varanasi: [
    { id: "vr1", title: "恒河边的第七盏灯",   genre: "梦境故事", style: "成人版", duration: "15:46", paid: false, plays: 21044,
      excerpt: "夜祭最后一盏灯总比第六盏多燃三秒。船夫说，那是她在等谁回头。",
      gen: "AI · 在地民间口述" },
  ],
  timbuktu: [
    { id: "tb1", title: "撒哈拉商队的盐与盐",  genre: "历史叙事", style: "历史版", duration: "17:30", paid: true,  plays: 10209,
      excerpt: "1325 年，一块陶里克盐在沙漠中被换了八次手，最后到了开罗。它从未减重。",
      gen: "考据 · 廷巴克图手稿数据库" },
    { id: "tb2", title: "图书馆的星图守护人", genre: "民间故事", style: "成人版", duration: "12:18", paid: false, plays: 6122,
      excerpt: "Mama Haidara 的曾祖父把四千份手稿埋进沙里。他没告诉地图，只告诉了月亮。",
      gen: "AI · 在地口述采集" },
  ],
  cusco: [
    { id: "cs1", title: "印加人的星座",       genre: "神话传说", style: "成人版", duration: "14:02", paid: false, plays: 11885,
      excerpt: "他们看星星之间的暗处——那才是他们的星座。骆马、蛇、狐狸，都住在黑里。",
      gen: "AI · 改编自克丘亚口传" },
  ],
};

// Default story for any active coord without a hand-written one — generated from template
function defaultStoriesFor(coord) {
  const c = CULTURES[coord.culture];
  return [
    { id: coord.id + "_a", title: `${coord.name}的夜行者`, genre: "民间故事", style: "成人版", duration: "12:34", paid: false, plays: Math.floor(coord.heat * 12000),
      excerpt: `在${coord.region}的某个雨夜，一位本地人把茶递给陌生人。陌生人没有脸，但茶喝光了。`,
      gen: `AI · 改编自${c.label}口述` },
    { id: coord.id + "_b", title: `${coord.name}的月亮契约`, genre: "梦境故事", style: "成人版", duration: "09:18", paid: false, plays: Math.floor(coord.heat * 6500),
      excerpt: `据说每逢满月，${coord.name}的钟会自己响一声。守夜人记下，但从不写在纸上。`,
      gen: `AI · 原创` },
  ];
}

function getStories(coordId) {
  if (STORIES[coordId]) return STORIES[coordId];
  const coord = COORDS.find(c => c.id === coordId);
  if (!coord || coord.dormant) return [];
  return defaultStoriesFor(coord);
}

const GENRES = [
  { id: "folk",     label: "民间故事" },
  { id: "myth",     label: "神话传说" },
  { id: "history",  label: "历史叙事" },
  { id: "nature",   label: "自然奇谈" },
  { id: "dream",    label: "梦境故事" },
];

const STYLES = [
  { id: "child", label: "儿童版" },
  { id: "adult", label: "成人版" },
  { id: "hist",  label: "历史版" },
];

Object.assign(window, { CULTURES, COORDS, STORIES, GENRES, STYLES, getStories, defaultStoriesFor });
